"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTopicDtoTestData = void 0;
const nomination_dto_spec_data_1 = require("./nomination.dto.spec.data");
function makeTopicDtoTestData(topicKey) {
    return {
        id: `topic${topicKey}-id`,
        name: `topic${topicKey}-name`,
        nominations: [nomination_dto_spec_data_1.makeNominationDtoTestData("1"), nomination_dto_spec_data_1.makeNominationDtoTestData("2"), nomination_dto_spec_data_1.makeNominationDtoTestData("3")],
        resultRanking: [nomination_dto_spec_data_1.makeNominationDtoTestData("2")],
        isClosed: true,
        totalMembers: 1,
        totalVoters: 1,
        allowNominate: true,
        allowVeto: true,
        autoClosePlayerCount: undefined
    };
}
exports.makeTopicDtoTestData = makeTopicDtoTestData;
;
//# sourceMappingURL=topic.dto.spec.data.js.map